var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 7,
    fill: "#41A1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.408 10.1656C22.9503 10.0916 23.4722 9.91648 23.9942 9.73467C24.0281 9.92321 23.906 9.99728 23.8383 10.0848C23.4925 10.5292 23.1062 10.94 22.652 11.2699C22.4418 11.4248 22.3876 11.5864 22.3944 11.8356C22.4283 16.0913 19.771 19.9968 15.7987 21.384C12.911 22.394 10.0843 22.1583 7.37961 20.7039C7.25081 20.6365 7.12202 20.5625 7 20.4884C7.00678 20.3133 7.12202 20.4143 7.19658 20.4211C8.9726 20.5288 10.5791 20.0642 12.084 18.9531C10.4571 18.7713 9.36576 17.9969 8.78957 16.502C9.30475 16.529 9.77248 16.5761 10.2402 16.4414C10.1656 16.3135 10.0369 16.3337 9.93517 16.2933C8.51843 15.7479 7.7321 14.7311 7.54907 13.2362C7.52196 12.9938 7.57619 12.9332 7.81344 13.0476C8.18627 13.2295 8.58621 13.3305 9.07428 13.3372C8.9387 13.216 8.8438 13.1285 8.74212 13.0409C7.58297 12.0039 7.24403 10.3003 7.90157 8.92662C8.01002 8.69768 8.07103 8.67074 8.25406 8.87275C9.98262 10.8323 12.1586 11.9635 14.7616 12.2867C14.7752 12.2867 14.7819 12.2867 14.7955 12.2935C15.3242 12.3541 15.3242 12.3541 15.2971 11.8221C15.2158 10.2936 15.9682 8.98722 17.3036 8.34752C18.6119 7.72802 20.1168 7.9435 21.2285 8.94009C21.3844 9.0815 21.5267 9.1017 21.7165 9.05456C22.3605 8.89295 22.9774 8.65054 23.6485 8.28692C23.3773 9.10843 22.9164 9.66733 22.2792 10.0983C22.2724 10.1858 22.2792 10.1926 22.408 10.1656Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3136a911f194b4f55becd56114452c47.svg";
export { ForwardRef as ReactComponent };